export default __webpack_public_path__ + "static/media/checklist.0f2188a9.png";